export default __webpack_public_path__ + "static/media/demoEtud.083affa9.mp4";